var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230.4 229.9",
    style: {
      enableBackground: "new 0 0 230.4 229.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2a61c1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.5,44.3c39.3,0,71.2,31.9,71.2,71.2s-31.9,71.2-71.2,71.2s-71.2-31.9-71.2-71.2S75.1,44.3,114.5,44.3  M114.5,31.6c-46.3,0-84,37.7-84,83.9s37.7,83.9,84,83.9s83.9-37.7,83.9-83.9S160.7,31.6,114.5,31.6L114.5,31.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.9,98.1c0-5.3-3.2-9.6-9.6-9.6c-4.4,0-8.3,2.2-11.4,5.7l-4.7-4.3c4.2-4.7,9.8-8.2,17-8.2 c10,0,16.6,6.1,16.6,15.8c0,13-16,18.3-14.4,32.1h-7.2C109.2,114.2,124.9,108.5,124.9,98.1z M109.2,144.3c0-3.7,2.7-6.3,5.9-6.3 c3.2,0,5.9,2.6,5.9,6.3c0,3.6-2.7,6.2-5.9,6.2C111.9,150.5,109.2,147.9,109.2,144.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.3c3e2bae5ba3bfaf28779a2463ea0372.svg";
export { ForwardRef as ReactComponent };